import { render } from "./ProjectStructurePage.vue?vue&type=template&id=2fd85cfc&scoped=true"
import script from "./ProjectStructurePage.vue?vue&type=script&lang=js"
export * from "./ProjectStructurePage.vue?vue&type=script&lang=js"

import "./ProjectStructurePage.vue?vue&type=style&index=0&id=2fd85cfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd85cfc"]])

export default __exports__